<template>
  <div class="default-modal">
    <el-dialog
      v-model="exportReportsDialogVisisble"
      title="Sendouts Report"
      width="60%"
      top="15vh"
      @close="close"
    >
      <div class="export-dialog-header">
        <div class="export-header-part"><h3>SENDOUTS REPORT</h3></div>

        <el-button
          size="medium"
          class="el-white"
          type="info"
          plain
          @click="close"
        >
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
        /></el-button>
      </div>
      <div class="selected-string">
        <h3 v-if="search_string">
          Selected String : <span class="value">{{ search_string }}</span>
        </h3>

        <h3 v-if="search_dob">
          Selected Date of Birth :
          <span class="value">{{ selectedDob(search_dob) }} </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="search_hospital && search_hospital.length"
      >
        <h3>
          Selected Hospital :
          <span class="value">{{ getSelectedHospital(search_hospital) }} </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="search_physician && search_physician.length"
      >
        <h3>
          Selected Physician :
          <span class="value">{{ getSelectedPhysician(search_physician) }} </span>
        </h3>
      </div>
      <div class="selected-string" v-if="search_status && search_status.length">
        <h3>
          Selected Status :

          <span
            class="value"
            v-for="(status, index) of getStatusMap(search_status)"
            :key="index"
            >{{ status }}
            <span v-if="index + 1 < search_status.length">,</span>
          </span>
        </h3>
      </div>
      <div class="selected-string" v-if="search_caseType && search_caseType.length">
        <h3>
          Selected caseType :
          <span
            class="value"
            v-for="(caseType, index) of getCaseTypeMap(search_caseType)"
            :key="index"
            >{{ caseType }}
            <span v-if="index + 1 < search_caseType.length">,</span>
          </span>
        </h3>
      </div>
      <div class="dialog-body" v-loading="loading">
        <div class="export-popup-body">
          <div class="select-fields">
            <el-checkbox-group v-model="activeFieldList">
              <ul class="select-fields-list">
                <li
                  class="search-checkbox"
                  v-for="(item, index) in exportSendOutsExcelFields"
                  :key="index"
                >
                  <el-checkbox :label="item.value">
                    {{ item.label }}
                  </el-checkbox>
                </li>
              </ul>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div class="dialog-footer export-footer w-95">
        <el-button
          class="cancel-button"
          @click="handleClear"
          :disabled="!this.activeFieldList.length"
          >CLEAR ALL</el-button
        >
        <el-button class="cancel-button" @click="handleCheckAllChange"
          >SELECT ALL</el-button
        >
        <el-button class="cancel-button" @click="close">CANCEL</el-button>
        <el-button class="blue-save-button" @click="downloadCases">
          DOWNLOAD
          <i class="el-icon-download"></i>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import AppHelper from "@/mixins/AppHelper";
import exportSendoutsHelper from "@/mixins/sendoutDataHelper";
import FilterHelper from "@/mixins/FilterHelper";
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
import moment from "moment";

export default {
  mixins: [
    UserPermissionsHelper,
    exportSendoutsHelper,
    caseDataHelper,
    AppHelper,
    FilterHelper,
  ],
  props: [
    "search_string",
    "search_patient_name",
    "search_hospital",
    "search_hospital_names",
    "search_physician",
    "search_dob",
    "search_caseType",
    "search_status",
    "pregnancy",
  ],
  computed: {
    ...mapGetters("sendOuts", ["getSendoutsDownloadStatus"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    getCaseTypeMap() {
      return (status) => {
        return (status || []).map((e) => this.caseTypeMap[e]);
      };
    },
    selectedDob() {
      return (search_dob) => moment(search_dob).format("YYYY-MM-DD");
    },
    getStatusMap() {
      return (status) => {
        return (status || []).map((e) => this.statusMap[e]);
      };
    },
  },
  data() {
    return {
      exportReportsDialogVisisble: true,
      fieldList: [],
      activeFieldList: [],
      checkAll: true,
      loading: false,
      date_type: "created_at",
      status: "",
      statusMap: caseConstants.STATUS_TYPE_MAP,
      hospital: "",
      ordering_physician: "",
      emr_client: "",
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
    };
  },
  created() {
    this.activeFieldList = [
      ...this.defaultExportSendOutsExcelFields.map((opt) => opt.value),
    ];
  },
  mounted() {
    this.status = this.search_status;
  },
  methods: {
    handleClear() {
      this.activeFieldList = [];
      this.fieldList = [];
    },
    getSelectedHospital(hospitalId) {
      // Prefer names passed from the parent: the hospitals store only holds the
      // most recently searched facilities, so resolving from it drops any
      // selected hospital that isn't in the latest search results.
      if (this.search_hospital_names && this.search_hospital_names.length) {
        return this.search_hospital_names.join(", ");
      }
      const ids = Array.isArray(hospitalId) ? hospitalId : [hospitalId];
      const hospitals =
        this.getAllHospitals && Array.isArray(this.getAllHospitals.data)
          ? this.getAllHospitals.data
          : [];
      return hospitals
        .filter((hospital) => ids.indexOf(hospital._id) != -1)
        .flatMap((hospital) => hospital.name)
        .join(", ");
    },
    getSelectedPhysician(physicianId) {
      const ids = Array.isArray(physicianId) ? physicianId : [physicianId];
      const physicians =
        this.getAllPhysicians && Array.isArray(this.getAllPhysicians.data)
          ? this.getAllPhysicians.data
          : [];
      return physicians
        .filter((physician) => ids.indexOf(physician._id) != -1)
        .flatMap((physician) => physician.name)
        .join(", ");
    },
    async downloadCases() {
      if (this.activeFieldList.length) {
        let params = {
          include: this.activeFieldList,
        };

        params.date_type = this.date_type;
        if (this.search_string != "") {
          params.search_string = this.search_string;
        }
        if (this.search_patient_name) {
          params.patient_name = this.search_patient_name;
        }
        if (this.search_hospital && this.search_hospital.length) {
          params.hospitals = this.search_hospital;
        }
        if (this.search_physician && this.search_physician.length) {
          params.ordering_physician = this.search_physician;
        }
        if (this.search_caseType && this.search_caseType.length) {
          params.case_types = this.search_caseType;
        }
        if (this.search_dob != "") {
          const date_of_birth = moment(this.search_dob).format("YYYY-MM-DD");

          params.date_of_birth = date_of_birth;
        }
        if (this.pregnancy) {
          params.pregnant = this.pregnancy;
        }
        if (
          this.status &&
          Array.isArray(this.status) &&
          this.status.length > 1
        ) {
          params.case_status = this.status;
        } else if (this.status && this.status.length) {
          params.status = this.status.toString();
        } else if (Object.keys(params).indexOf("status") != -1) {
          delete params.status;
        }
        if(this.isGowthamUser){
          params.is_old = true
        }
        this.loading = true;
        await this.$store.dispatch("sendOuts/downloadSendOutData", params);
        this.loading = false;
        if (this.getSendoutsDownloadStatus) {
          this.close();
          //   this.closeExportDialog();
          //   this.closeExportReportsDialog();
        } else {
          this.$message({
            message: "Error in downloading cases",
            type: "error",
          });
        }
      } else {
        this.$message({
          message: "Please select the data fields.",
          type: "warning",
        });
      }
    },
    resetAllFilters() {
      this.fieldList = [];
      this.activeFieldList = [];
      this.date_type = "created_at";
    },
    close() {
      this.$emit("close");
    },
    handleCheckAllChange() {
      this.activeFieldList = [];
      this.fieldList = [];
      this.exportSendOutsExcelFields.forEach((obj) => {
        this.fieldList.push(obj.value);
      });
      this.activeFieldList = this.fieldList;
    },
  },
};
</script>
<style lang="scss" scoped>
.select-fields {
  ul {
    -webkit-column-count: 3;
    column-count: 3;
    -webkit-column-gap: 20px;
    column-gap: 20px;
    li {
      &:not(:last-child) {
        margin-bottom: 5px;
      }
    }
  }
}
</style>
